// Configuration centralisée pour les URLs de l'API
const getBaseUrl = () => {
  // Si on est en développement local
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:5800/api';
  }
  
  // En production, utiliser l'origine actuelle avec /api
  // Cela fonctionne pour st.ineo.dev ou tout autre domaine
  if (window.location.protocol === 'https:') {
    return `${window.location.origin}/api`;
  }
  
  // Fallback vers la variable d'environnement ou localhost
  return import.meta.env.VITE_API_URL || 'http://localhost:5800/api';
};

// Fonction pour obtenir l'URL de base dynamiquement
const getDynamicBaseUrl = () => {
  const baseUrl = getBaseUrl();
  console.log('🌐 API Base URL:', baseUrl, 'Hostname:', window.location.hostname);
  return baseUrl;
};

export const API_CONFIG = {
  get BASE_URL() {
    return getDynamicBaseUrl();
  },
  ENDPOINTS: {
    SESSIONS: '/games/storm/sessions',
    MESSAGES: '/games/storm/messages',
    SUBMISSIONS: '/games/storm/submissions',
    PROGRESS: '/games/storm/progress',
    IMPORT: '/games/storm/import',
    CONFIG: '/games/storm/config',
    SESSION_CONFIG: '/games/storm/session'
  }
} as const;

// Helper function to build full URLs
export const buildApiUrl = (endpoint: string, ...params: string[]): string => {
  const baseUrl = API_CONFIG.BASE_URL;
  const path = params.length > 0 ? `${endpoint}/${params.join('/')}` : endpoint;
  return `${baseUrl}${path}`;
};

// Specific URL builders
export const apiUrls = {
  sessionConfig: (sessionId: string) => 
    buildApiUrl(API_CONFIG.ENDPOINTS.SESSION_CONFIG, sessionId, 'config'),
  importConfig: (sessionId: string) => 
    buildApiUrl(API_CONFIG.ENDPOINTS.IMPORT, sessionId),
  saveConfig: () => 
    buildApiUrl(API_CONFIG.ENDPOINTS.CONFIG, 'save'),
  loadConfigs: () => 
    buildApiUrl(API_CONFIG.ENDPOINTS.CONFIG, 'saved'),
  loadConfig: (configId: string) => 
    buildApiUrl(API_CONFIG.ENDPOINTS.CONFIG, configId),
  deleteConfig: (configId: string) => 
    buildApiUrl(API_CONFIG.ENDPOINTS.CONFIG, configId)
};
